// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__JO3y5"};